// extracted by mini-css-extract-plugin
export default {"togglerWrapper":"qWKD","togglerButton":"Rd6L"};